import React from 'react';

import SaleBaseGame from './SaleBaseGame';
function MarketplaceGame() {
  return <SaleBaseGame saleType="Marketplace" />;
}

export default MarketplaceGame;
